import {useContext} from "react";

import ToastContext from "../../contexts/ToastContext";

export const useToast = () => {
    const {toast} = useContext(ToastContext);

    return toast;
};
